module.exports = __webpack_public_path__ + "static/img/Eniksen_Logo_BW_def.77a8dcc4.jpg";